<template>
  <AppConfig v-model:configuratorVisible="configuratorVisible" />
  <div :class="['layout-topbar', topbarClass]">
    <router-link to="/" class="layout-topbar-logo">
      <img alt="Logo" src="../../../public/images/sespa/brasao.svg" />
      <h2 class="ml-4 mb-4">PLANTÕES</h2>
    </router-link>
    <button
      class="p-link layout-menu-button layout-topbar-button"
      @click="onMenuToggle"
    >
      <i class="pi pi-bars"></i>
    </button>

    <button
      class="p-link layout-topbar-menu-button layout-topbar-button"
      v-styleclass="{
        selector: '@next',
        enterClass: 'hidden',
        enterActiveClass: 'scalein',
        leaveToClass: 'hidden',
        leaveActiveClass: 'fadeout',
        hideOnOutsideClick: true,
      }"
    >
      <i class="pi pi-ellipsis-v"></i>
    </button>
    {{ environmentLabel }}
    <ul class="layout-topbar-menu hidden lg:flex origin-top">
      <li>
        <button
          class="p-link layout-topbar-button"
          v-tooltip="'CONFIGURAÇÕES DE ACESSIBILIDADE'"
          @click="toggleConfigurator"
        >
          <i class="pi pi-cog"></i>
          <span>Acessibilidade</span>
        </button>
      </li>
      <li>
        <button class="p-link layout-topbar-button" @click="signOut">
          <i class="pi pi-sign-out"></i>
          <span>Sair</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import AuthService from "../../service/auth/auth_service";
//COMPONENTS
import AppConfig from "../menu/AppConfig.vue";

export default {
  components: {
    AppConfig,
  },
  data() {
    return {
      authService: new AuthService(),
      configuratorVisible: false,
    };
  },
  computed: {
    topbarClass() {
      switch (process.env.VUE_APP_ENV) {
        case "development":
          return "topbar-development";
        case "staging":
          return "topbar-staging";
        case "training":
          return "topbar-training";
        default:
          return "";
      }
    },
    environmentLabel() {
      switch (process.env.VUE_APP_ENV) {
        case "development":
          return "AMBIENTE DE DESENVOLVIMENTO";
        case "staging":
          return "AMBIENTE DE HOMOLOGAÇÃO";
        case "training":
          return "AMBIENTE DE TREINAMENTO";
        default:
          return "";
      }
    },
  },
  methods: {
    toggleConfigurator() {
      this.configuratorVisible = !this.configuratorVisible;
    },
    onMenuToggle(event) {
      this.$emit("menu-toggle", event);
    },
    onTopbarMenuToggle(event) {
      this.$emit("topbar-menu-toggle", event);
    },
    signOut() {
      window.location.replace(this.$UrlIntranet);
    },
  },
};
</script>


<style scoped>
.layout-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  height: 60px;
}

.environment-label {
  flex-grow: 1;
  text-align: center;
  font-weight: bold;
  font-size: 1.2em;
}

.topbar-development {
  background-color: #f8d7da; /* Vermelho claro */
  color: #721c24; /* Texto vermelho escuro */
}

.topbar-staging {
  background: #e7e439;
  /* Amarelo */
  color: #857804;
  /* Texto amarelo escuro */
}

.topbar-training {
  background-color: #73ee68; /* Verde */
  color: #197007; /* Texto Verde Escuro */
}
</style>
